import { addedScrollLengthProperty } from "hooks/useScrollableBlock";

import { getDataAttributeByPropertyName } from "utils/getDataAttributeByPropertyName";

interface ScrollToElementOptions extends ScrollOptions {
    offset?: number;
}

/**
 * Scrolls to the given element accounting for preceding scrollable blocks appearing prior
 * in the document thus altering scroll length to the element
 * @param element
 * @param options
 * @see useScrollableBlock
 */
export const scrollToElement = (
    element: HTMLElement,
    options?: ScrollToElementOptions
) => {
    const { offset = 0, ...scrollOptions } = options || {};
    const scrollableBlocks = document.querySelectorAll(
        `[${getDataAttributeByPropertyName(addedScrollLengthProperty)}]`
    );
    const elementOffsetTop = element.offsetTop;
    const addedPriorScroll = Array.from(scrollableBlocks).reduce(
        (result, item) => {
            if (
                item instanceof HTMLElement &&
                item.offsetTop < elementOffsetTop
            ) {
                const addedScrollLength =
                    Number(item.dataset[addedScrollLengthProperty]) || 0;
                return addedScrollLength + result;
            }
            return result;
        },
        0
    );
    const adjustedElementOffset = elementOffsetTop + addedPriorScroll;

    window.scrollTo({
        top: adjustedElementOffset - offset,
        ...scrollOptions,
    });
};
